import { useMutation, useSuspenseQuery } from "@tanstack/react-query";
import { AlertBar } from "@/components/AlertBar";
import { Button } from "@/components/catalyst/Button";
import { orpc } from "@/orpc/client";

/**
 * Banner displayed when a user's subscription has payment issues.
 * Shows a warning for past_due and an error for unpaid status.
 */
export function SubscriptionStatusBanner() {
	const { data: subscription } = useSuspenseQuery(
		orpc.billing.getSubscription.queryOptions(),
	);

	const openPortal = useMutation(
		orpc.billing.createPortalSession.mutationOptions({
			onSuccess: (data) => {
				window.open(data.url, "_blank");
			},
		}),
	);

	if (subscription.status !== "past_due" && subscription.status !== "unpaid") {
		return null;
	}

	const isPastDue = subscription.status === "past_due";

	return (
		<AlertBar
			variant={isPastDue ? "warning" : "error"}
			title={isPastDue ? "Payment Past Due" : "Payment Failed"}
			action={
				<Button
					type="button"
					outline
					onClick={() => openPortal.mutate({})}
					disabled={openPortal.isPending}
				>
					{openPortal.isPending ? "Opening..." : "Update Payment Method"}
				</Button>
			}
		>
			{isPastDue
				? "We were unable to process your latest payment. Please update your payment method to avoid service interruption."
				: "All payment attempts have failed. Please update your payment method to keep your account active."}
		</AlertBar>
	);
}
